import { render, staticRenderFns } from "./AiFactor.vue?vue&type=template&id=a5ef5258&scoped=true&"
import script from "./AiFactor.vue?vue&type=script&lang=ts&"
export * from "./AiFactor.vue?vue&type=script&lang=ts&"
import style0 from "./AiFactor.vue?vue&type=style&index=0&id=a5ef5258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ef5258",
  null
  
)

export default component.exports